// @flow
import React from 'react';
import {Form} from 'reactstrap';

/**
 * Form obal - poskytuje context pro Fieldy (FieldGrid,...)
 */
class CustomForm extends React.Component {

    static childContextTypes = {
        form: React.PropTypes.bool,
        horizontal: React.PropTypes.bool,
        inline: React.PropTypes.bool,
    };

    getChildContext() {
        const {horizontal, inline} = this.props;

        return {horizontal: (horizontal ? true : false), inline: (inline ? true : false), form: true};
    }

    render() {
        const {form, horizontal, ...other} = this.props;

        return <Form {...other} />;
    }
}

export default CustomForm
